
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuDataService {
    openedSubMenuIndex: number = -1;
    private messageSource = new BehaviorSubject(null);
    currentMenu = this.messageSource.asObservable();

    constructor() { }

    loadMenu(message: any) {
        this.messageSource.next(message)
    }

}